import React from 'react';
import { Collapse } from 'antd';
const { Panel } = Collapse
const text = `
  A dog is a type of domesticated animal.
  Known for its loyalty and faithfulness,
  it can be found as a welcome guest in many households across the world.
`;
const items = [
  {
    key: '1',
    label: 'This is panel header 1',
    children: <p>{text}</p>,
  },
  {
    key: '2',
    label: 'This is panel header 2',
    children: <p>{text}</p>,
  },
  {
    key: '3',
    label: 'This is panel header 3',
    children: <p>{text}</p>,
  },
];
const PlayerInviteFAQ = () => {
  
  return (<div className='p-4'>

<Collapse accordion size="large" >
              
                <Panel
                  header={'How to invite players'} 
                >
                  <div className='TableContainer'>
                   yfhchfgcghb
                  </div>
                </Panel>
                <Panel
                  header={'Boost productivity with your team'} 
                >
                  <div className='TableContainer'>
                   <p>Loom is better when you know who you’re working with. Make work easier and faster with your teammates.
</p>
                  </div>
                </Panel>
            </Collapse></div>);
};
export default PlayerInviteFAQ;